export default function tickFilter(ticks, discontinuityProvider) {
  var discontinuousTicks = ticks.map(discontinuityProvider.clampUp);

  if (discontinuousTicks.length !== new Set(discontinuousTicks.map(function (d) {
    return d === null || d === void 0 ? void 0 : d.valueOf();
  })).size) {
    console.warn('There are multiple ticks that fall within a discontinuity, which has led to them being rendered on top of each other. Consider using scale.ticks to explicitly specify the ticks for the scale.');
  }

  return discontinuousTicks;
}